module.exports = __webpack_public_path__ + "Icono_InfoPProductoTSI_126px.png";